import React, { useEffect, useState } from 'react';
import { collection, doc, getDoc, getDocs, getFirestore, query, where } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';

import * as Core from '@lexome/core';

// import { bookRegex } from './Page';

const bookImport = require('../../eleanorLives.json');

export const BookContext = React.createContext<{
  authors?: Core.Author[];
  book?: Core.Book;
  content?: Core.Chapter[];
  // openBook: (book: Core.Book) => Promise<void>;
}>({ authors: undefined, book: undefined, content: undefined });

export function BookProvider({ children }: { children: JSX.Element }): JSX.Element {
  const [authors, setAuthors] = useState<Core.Author[]>();
  // const [book, setBook] = useState<Core.Book>();
  // const [content, setContent] = useState<Core.Chapter[]>();

  // const openBook = async (bookOrId: Core.Book | string): Promise<void> => {
  //   let book: Core.Book;

  //   if (typeof bookOrId === 'string') {
  //     book = {
  //       ...((await getDoc(doc(getFirestore(), 'book', bookOrId))).data() as Omit<Core.Book, 'id'>),
  //       id: bookOrId,
  //     };
  //   } else book = bookOrId;

  //   setBook(book);
  //   window.history.pushState({}, '', `/books/${book.id}`);

  //   if (book.authorIds.length) {
  //     void getDocs(
  //       query(collection(getFirestore(), 'author'), where('__name__', 'in', book.authorIds))
  //     ).then((query) => {
  //       setAuthors(query.docs.map((doc) => doc.data() as Core.Author));
  //     });
  //   } else setAuthors([]);

  //   void httpsCallable(
  //     getFunctions(),
  //     'downloadBookFile'
  //   )(`${book.id}/content.json`).then(({ data }) => {
  //     setContent(data as Core.Chapter[]);
  //   });
  // };

  // useEffect(() => {
  //   if (bookRegex.test(location.pathname)) {
  //     void openBook(location.pathname.match(/[a-zA-Z0-9]{20}/)![0]);
  //   }
  // }, []);
  const book = {
    title: 'International Bill Of Rights',
    description: 'International Bill Of Rights',
    id: '1',
    authorIds: [],
    subjectIds: []
  };

  return (
    <BookContext.Provider value={{ authors, content: bookImport, book }}>
      {children}
    </BookContext.Provider>
  );
}
